<mat-card class="mb-25 enrolled-created-box ccorbit-card">
  <mat-card-content>
    <div class="ccorbit-form-group without-icon">
      <div class="row">
        <!-- Fecha Selection Group -->
        <div class="col-xl-3">
          <label class="fw-semibold gray-color">Seleccionar Fecha</label>
          <div>
            <mat-radio-group [(ngModel)]="fechaSeleccionada" (change)="onFechaSeleccionadaChange()">
              <mat-radio-button value="fechaInicio">Fecha Inicial</mat-radio-button>
              <!--mat-radio-button value="fechaPeriodo">Fecha Período</mat-radio-button-->
            </mat-radio-group>
          </div>
        </div>
        <div class="col-xl-3" *ngIf="fechaSeleccionada === 'fechaInicio'">
          <label class="fw-semibold gray-color">Fecha inicial</label>
          <input type="date" name="fechaInicio" id="" [(ngModel)]="fechaInicio">
        </div>
        <div class="col-xl-3" *ngIf="fechaSeleccionada === 'fechaPeriodo'">
          <label class="fw-semibold gray-color">Fecha período</label>
          <input type="date" name="fechaPeriodo" id="" [(ngModel)]="fechaPeriodo">
        </div>
        <div class="col-xl-3" *ngIf="modeloSeleccionadoTipo === 'modelo'">
          <label class="fw-semibold gray-color">Seleccionar</label>
          <select class="form-select form-select-sm listas"
                  aria-label=".form-select-sm example"
                  (change)="consultarOperaciones()"
                  [(ngModel)]="modeloSeleccionado">
            <option [ngValue]="modelo.idmodelo" *ngFor="let modelo of listaModelos">
              {{ modelo.nombreCartera }}</option>
          </select>
        </div>
        <div class="col-xl-3" *ngIf="modeloSeleccionadoTipo === 'cartera'">
          <label class="fw-semibold gray-color">Seleccionar</label>
          <select class="form-select form-select-sm listas"
                  aria-label=".form-select-sm example"
                  (change)="consultarOperaciones()"
                  [(ngModel)]="idModeloSeleccionado">
            <option [ngValue]="modelo.idcartera" *ngFor="let modelo of listaCarteras">
              {{ modelo.nombreCartera }}</option>
          </select>
        </div>
        
        <!-- Consult Button -->
        <div class="col-xl-3">
          <button (click)="consultarOperaciones()"
                  mat-flat-button class="ccorbit d-block fw-semibold">
            Consultar
          </button>
        </div>
      </div>
    </div>
  </mat-card-content>
</mat-card>


  

  <!--mat-form-field>
    <mat-label>Seleccionar modelo</mat-label>
    <mat-select [(ngModel)]="modeloSeleccionado" (selectionChange)="consultarOperaciones()" name="selectModelo">
      @for (modelo of listaModelos; track modelo) {
      <mat-option [value]="modelo.idmodelo">{{
        modelo.nombreCartera
        }}</mat-option>
      }
    </mat-select>
  </mat-form-field-->

  <!--button mat-raised-button color="primary" (click)="consultarOperaciones()">
    Consultar
  </button-->


<ng-container *ngIf="listaOperaciones"></ng-container>
<table mat-table [dataSource]="listaOperaciones" class="table-striped tableStyle">
  <ng-container *ngFor="let tablecolope of tableColumns">
    <ng-container [matColumnDef]="tablecolope.id">
      <th mat-header-cell *matHeaderCellDef (click)="sortBy(tablecolope)" class="sortable-header">
        {{ tablecolope.name }}
        <i class="material-icons align-middle ml-1" *ngIf="sortColumnId === tablecolope.id">
          {{ sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward' }}
        </i>
      </th>
      <!--td  mat-cell *matCellDef="let element">{{ element[tablecolope.id] }}</td-->
      <td mat-cell *matCellDef="let element">
        <a *ngIf="tablecolope.id == 'nombrecompania'" [routerLink]="[
            '/grafica-modelo/idNectum=' +
              element.idnectum +
              '&nombreComp=' +
              element.nombrecompania +
              '&idModelo=' +
              element.idmodelo +
              '&isModelo=modelo'
          ]" target="_blank" rel="noopener noreferrer">
          {{ element[tablecolope.id] }}</a>
          <a *ngIf="tablecolope.id == 'vermodelo'" [routerLink]="['/models']" [queryParams]="{id: element.idmodelo}" target="_blank" rel="noopener noreferrer">
            Ver Modelo
          </a>
        <p *ngIf="checkColumnaNumerica(tablecolope)">
          {{ element[tablecolope.id] | number : '1.2-2' }}
        </p>
        <p *ngIf="!checkColumnaNumerica(tablecolope) && tablecolope.id !== 'nombrecompania' && tablecolope.id !== 'vermodelo'">
          {{ element[tablecolope.id]}}
        </p>
      </td>
    </ng-container>
  </ng-container>

  <!--- Note that these columns can be defined in any order.
          The actual rendered columns are set as a property on the row definition" -->

  <tr mat-header-row *matHeaderRowDef="operacionesColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: operacionesColumns"></tr>
</table>
<mat-paginator [pageSizeOptions]="[100]" [length]="totalRegistros" [pageIndex]="pagina" (page)="cambioDePagina($event)"
  aria-label="Select page of periodic elements">
</mat-paginator>
